import { FC } from "react";
import { PrimaryButton, ButtonProps } from "./PrimaryButton";
import { DangerButton } from "./DangerButton";
import { ButtonVariant } from "./types";

export const Button: FC<ButtonProps> = ({
  children,
  variant = ButtonVariant.DEFAULT,
  ...buttonProps
}) => {
  switch (variant) {
    case ButtonVariant.DANGER:
      return <DangerButton {...buttonProps}>{children}</DangerButton>;
    case ButtonVariant.DISABLED:
      return (
        <PrimaryButton {...buttonProps} disabled>
          {children}
        </PrimaryButton>
      );
    case ButtonVariant.DEFAULT:
    default:
      return <PrimaryButton {...buttonProps}>{children}</PrimaryButton>;
  }
};
